// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mod-border[data-v-8f717b26] {\n  border: 1px solid darkslategray;\n  border-radius: 2px;\n  transition: all 0.3s ease-in-out;\n}\n.mod-border[data-v-8f717b26]:hover {\n  border-color: black;\n}\n", ""]);
// Exports
module.exports = exports;
